<div class="dialog-width">
  <form [formGroup]="loginFormGroup">
    <button class="close-button" mat-icon-button [mat-dialog-close]="false">
      <mat-icon>close</mat-icon>
    </button>

    <h1 mat-dialog-title>{{ "log-in" | translate }}</h1>
    <div mat-dialog-content>
      <mat-form-field>
        <mat-label>{{ "mail-address" | translate }}</mat-label>
        <input type="email" matInput formControlName="email" />
        <mat-icon matPrefix>mail</mat-icon>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "password" | translate }}</mat-label>
        <input [type]="!showPassword ? 'password' : 'text'" matInput formControlName="password" />
        <mat-icon matPrefix>vpn_key</mat-icon>
        <mat-icon (click)="showPassword = !showPassword" *ngIf="showPassword" matSuffix>visibility</mat-icon>
        <mat-icon (click)="showPassword = !showPassword" *ngIf="!showPassword" matSuffix>visibility_off</mat-icon>
      </mat-form-field>

    </div>
    <div mat-dialog-actions align="end">
      <button class="full-width" mat-raised-button color="primary" [mat-dialog-close]="true" (click)="login()"
        [disabled]="!loginFormGroup.valid" cdkFocusInitial>
        {{ "log-in" | translate }}
      </button>
    </div>
  </form>
</div>
